export type DragType = 'insideOneGroup' | 'fromGroupToGroup';
export type DragSubType = 'singledrag' | 'multidrag';
export type GroupMoveDirection = 1 | 0;
export const GROUP_PAGE_SIZE = 30;
export const DefaultCustomUnGroupedName = 'Ungrouped analyses';
export const DefaultCustomUnGroupedNameI18nKey = 'ungroupedAnalyses';
export type EmptyAnalysisType =
  | 'NoAnalysesNoKFA'
  | 'NoKFA'
  | 'None'
  | 'NotFound';
export type GroupType = 'custom' | 'kfa' | 'none';
export const CUSTOM_GROUP_NAME = 'custom';
export const KFA_GROUP_NAME = 'kfa';
export const NONE_GROUP_NAME = 'none';
export const ADD_GROUP_API_ERROR =
  'Unable to add group. Please refresh the page to try again.';
